import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  orderBy,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

const Comments = ({ newsId }) => {
  const [commentName, setCommentName] = useState("");
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);
  const [showAllComments, setShowAllComments] = useState(false);

  const [replyingTo, setReplyingTo] = useState(null);
  const [replyName, setReplyName] = useState("");
  const [replyText, setReplyText] = useState("");

  const [likedComments, setLikedComments] = useState(() => {
    try {
      return JSON.parse(
        localStorage.getItem("likedComments") || "{}"
      );
    } catch {
      return {};
    }
  });

  // =========================
  // FETCH COMMENTS
  // =========================
  const fetchComments = async () => {
    try {
      const q = query(
        collection(db, "comments"),
        where("newsId", "==", newsId),
        orderBy("createdAt", "desc")
      );

      const snapshot = await getDocs(q);

      setComments(
        snapshot.docs.map((commentDoc) => ({
          id: commentDoc.id,
          ...commentDoc.data(),
        }))
      );
    } catch (error) {
      console.error("FETCH COMMENTS ERROR:", error);
    }
  };

  useEffect(() => {
    if (newsId) {
      fetchComments();
    }
  }, [newsId]);

  // =========================
  // SUBMIT NEW COMMENT
  // =========================
  const submitComment = async () => {
    if (!commentName.trim() || !commentText.trim()) {
      alert("নাম ও মন্তব্য লিখুন");
      return;
    }

    try {
      const docRef = await addDoc(
        collection(db, "comments"),
        {
          newsId,
          name: commentName.trim(),
          text: commentText.trim(),
          createdAt: serverTimestamp(),
          likes: 0,
          parentId: null,
        }
      );

      console.log("COMMENT SAVED:", docRef.id);

      setCommentName("");
      setCommentText("");

      fetchComments();
    } catch (error) {
      console.error("COMMENT SAVE ERROR:", error);
      alert(
        "মন্তব্য সংরক্ষণ করা যায়নি: " + error.message
      );
    }
  };

  // =========================
  // SUBMIT REPLY
  // =========================
  const submitReply = async (parentId) => {
    if (!replyName.trim() || !replyText.trim()) {
      alert("নাম ও Reply লিখুন");
      return;
    }

    try {
      await addDoc(
        collection(db, "comments"),
        {
          newsId,
          name: replyName.trim(),
          text: replyText.trim(),
          createdAt: serverTimestamp(),
          likes: 0,
          parentId,
        }
      );

      setReplyName("");
      setReplyText("");
      setReplyingTo(null);

      fetchComments();
    } catch (error) {
      console.error("REPLY SAVE ERROR:", error);
      alert(
        "Reply সংরক্ষণ করা যায়নি: " + error.message
      );
    }
  };

  // =========================
  // LIKE
  // =========================
  const handleLike = async (commentId) => {
    if (likedComments[commentId]) {
      return;
    }

    try {
      await updateDoc(
        doc(db, "comments", commentId),
        {
          likes: increment(1),
        }
      );

      const updatedLikes = {
        ...likedComments,
        [commentId]: true,
      };

      setLikedComments(updatedLikes);

      localStorage.setItem(
        "likedComments",
        JSON.stringify(updatedLikes)
      );

      setComments((prevComments) =>
        prevComments.map((comment) =>
          comment.id === commentId
            ? {
                ...comment,
                likes: (comment.likes || 0) + 1,
              }
            : comment
        )
      );
    } catch (error) {
      console.error("LIKE ERROR:", error);
      alert(
        "Like দেওয়া যায়নি: " + error.message
      );
    }
  };

  // =========================
  // MAIN COMMENTS & REPLIES
  // =========================
  const mainComments = comments.filter(
    (comment) => !comment.parentId
  );

  const getReplies = (commentId) => {
    return comments.filter(
      (comment) => comment.parentId === commentId
    );
  };

  return (
    <div
      style={{
        marginTop: "8px",
        borderTop: "1px solid #ddd",
        paddingTop: "8px",
      }}
    >
      {/* =========================
          HEADER
      ========================= */}
      <h3
        style={{
          margin: "0 0 4px 0",
          padding: 0,
          fontSize: "16px",
          color: "#d2202a",
        }}
      >
        💬 মন্তব্য ({mainComments.length})
      </h3>

      {/* =========================
          NEW COMMENT
      ========================= */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          alignItems: "flex-start",
          marginBottom: "15px",
          flexWrap: "wrap",
        }}
      >
        {/* NAME */}
        <input
          type="text"
          placeholder="আপনার নাম"
          value={commentName}
          onChange={(e) =>
            setCommentName(e.target.value)
          }
          style={{
            width: "150px",
            height: "30px",
            padding: "0 10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
            lineHeight: "30px",
            boxSizing: "border-box",
            flexShrink: 0,
            margin: 0,
          }}
        />

        {/* COMMENT + SUBMIT */}
        <div
          style={{
            position: "relative",
            flex: 1,
            minWidth: 0,
            height: "30px",
            margin: 0,
          }}
        >
          <input
            type="text"
            placeholder="মন্তব্য"
            value={commentText}
            onChange={(e) =>
              setCommentText(e.target.value)
            }
            style={{
              width: "100%",
              height: "30px",
              padding: "0 100px 0 10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "30px",
              boxSizing: "border-box",
              outline: "none",
              display: "block",
              margin: 0,
            }}
          />

          <button
            onClick={submitComment}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              height: "30px",
              padding: "0 18px",
              border: "none",
              borderRadius: "0 6px 6px 0",
              background: "#d2202a",
              color: "#fff",
              cursor: "pointer",
              margin: 0,
            }}
          >
            সাবমিট
          </button>
        </div>
      </div>

      {/* =========================
          NO COMMENTS
      ========================= */}
      {mainComments.length === 0 ? (
        <div
          style={{
            color: "#777",
            margin: 0,
            padding: 0,
            fontSize: "14px",
            lineHeight: "1.4",
          }}
        >
          এখনো কোনো মন্তব্য করা হয়নি।
        </div>
      ) : (
        <>
          {/* =========================
              COMMENTS
          ========================= */}
          {(showAllComments
            ? mainComments
            : mainComments.slice(0, 3)
          ).map((comment) => {
            const replies = getReplies(comment.id);

            return (
              <div
                key={comment.id}
                style={{
                  padding: "6px 0",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* COMMENT NAME */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                    margin: "0 0 1px 0",
                    padding: 0,
                    fontSize: "14px",
                    fontWeight: "bold",
                    lineHeight: "18px",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      minWidth: "8px",
                      background: "#d2202a",
                      borderRadius: "50%",
                      display: "inline-block",
                    }}
                  />

                  {comment.name}
                </div>

                {/* COMMENT TEXT */}
                <div
                  style={{
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.7",
                    wordBreak: "break-word",
                  }}
                >
                  {comment.text}
                </div>

                {/* LIKE + REPLY */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginTop: "3px",
                    lineHeight: "16px",
                  }}
                >
                  {/* LIKE */}
                  <button
                    onClick={() =>
                      handleLike(comment.id)
                    }
                    style={{
                      border: "none",
                      background: "none",
                      padding: 0,
                      margin: 0,
                      lineHeight: "16px",
                      fontFamily: "inherit",
                      cursor: likedComments[comment.id]
                        ? "default"
                        : "pointer",
                      color: likedComments[comment.id]
                        ? "#d2202a"
                        : "#777",
                      fontSize: "12px",
                      fontWeight: likedComments[comment.id]
                        ? "bold"
                        : "normal",
                    }}
                  >
                    {likedComments[comment.id]
                      ? "♥"
                      : "♡"}{" "}
                    Like{" "}
                    {comment.likes > 0
                      ? `(${comment.likes})`
                      : ""}
                  </button>

                  {/* REPLY */}
                  <button
                    onClick={() =>
                      setReplyingTo(
                        replyingTo === comment.id
                          ? null
                          : comment.id
                      )
                    }
                    style={{
                      border: "none",
                      background: "none",
                      padding: 0,
                      margin: 0,
                      lineHeight: "16px",
                      fontFamily: "inherit",
                      cursor: "pointer",
                      color: "#777",
                      fontSize: "12px",
                    }}
                  >
                    ↩ Reply
                  </button>
                </div>

                {/* =========================
                    REPLY INPUT
                ========================= */}
                {replyingTo === comment.id && (
                <div
  style={{
    marginTop: "5px",
    marginLeft: "15px",
    display: "flex",
    alignItems: "flex-start",
    gap: "7px",
    // flexWrap: "wrap",   // বাদ দিন, বা নিচের মত রাখুন
  }}
>
                   {/* REPLY NAME */}
  <input
    type="text"
    placeholder="আপনার নাম"
    value={replyName}
    onChange={(e) => setReplyName(e.target.value)}
    style={{
      width: "90px",           // 👈 কমিয়ে দিন
      flexShrink: 0,           // 👈 যোগ করুন, যাতে squeeze না হয়
      height: "28px",
      padding: "0 8px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      fontSize: "12px",
      lineHeight: "28px",
      boxSizing: "border-box",
      margin: 0,
    }}
  />

                  {/* REPLY TEXT + BUTTON */}
  <div
    style={{
      position: "relative",
      flex: 1,
      minWidth: "80px",        // 👈 150 থেকে কমিয়ে
      height: "28px",
      margin: 0,
    }}
  >
                      <input
                        type="text"
                        placeholder="Reply লিখুন"
                        value={replyText}
                        onChange={(e) =>
                          setReplyText(e.target.value)
                        }
                        style={{
                          width: "100%",
                          height: "28px",
                          padding: "0 65px 0 8px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          fontSize: "12px",
                          lineHeight: "28px",
                          boxSizing: "border-box",
                          outline: "none",
                          margin: 0,
                        }}
                      />

                      <button
                        onClick={() =>
                          submitReply(comment.id)
                        }
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          height: "28px",
                          padding: "0 10px",
                          border: "none",
                          borderRadius: "0 5px 5px 0",
                          background: "#d2202a",
                          color: "#fff",
                          fontSize: "12px",
                          lineHeight: "28px",
                          cursor: "pointer",
                          margin: 0,
                        }}
                      >
                        Reply
                      </button>
                    </div>
                  </div>
                )}

                {/* =========================
                    REPLIES
                ========================= */}
                {replies.length > 0 && (
                  <div
                    style={{
                      marginTop: "6px",
                      marginLeft: "10px",
                      paddingLeft: "9px",
                      borderLeft: "2px solid #eee",
                    }}
                  >
                    {replies.map((reply) => (
                      <div
                        key={reply.id}
                        style={{
                          padding: "4px 0",
                          margin: 0,
                          fontSize: "13px",
                          lineHeight: "18px",
                          wordBreak: "break-word",
                        }}
                      >
                        {/* REPLY NAME */}
                        <span
                          style={{
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span
                            style={{
                              width: "6px",
                              height: "6px",
                              minWidth: "6px",
                              background: "#d2202a",
                              borderRadius: "50%",
                              display: "inline-block",
                              marginRight: "5px",
                              verticalAlign: "middle",
                            }}
                          />

                          {reply.name}:
                        </span>{" "}

                        {/* REPLY TEXT */}
                        <span
                          style={{
                            fontSize: "13px",
                            lineHeight: "18px",
                          }}
                        >
                          {reply.text}
                        </span>{" "}

                        {/* REPLY LIKE */}
                        <button
                          onClick={() =>
                            handleLike(reply.id)
                          }
                          style={{
                            display: "inline",
                            border: "none",
                            background: "none",
                            padding: 0,
                            margin: "0 0 0 6px",
                            fontSize: "11px",
                            lineHeight: "18px",
                            fontFamily: "inherit",
                            color: likedComments[reply.id]
                              ? "#d2202a"
                              : "#777",
                            cursor: likedComments[reply.id]
                              ? "default"
                              : "pointer",
                            verticalAlign: "baseline",
                          }}
                        >
                          {likedComments[reply.id]
                            ? "♥"
                            : "♡"}{" "}
                          Like{" "}
                          {reply.likes > 0
                            ? `(${reply.likes})`
                            : ""}
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}

          {/* =========================
              SHOW MORE
          ========================= */}
          {mainComments.length > 3 && (
            <div
              onClick={() =>
                setShowAllComments(!showAllComments)
              }
              style={{
                marginTop: "15px",
                textAlign: "center",
                color: "#d2202a",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "13px",
              }}
            >
              {showAllComments
                ? "▲ মন্তব্য Hide করুন"
                : `▼ আরও ${
                    mainComments.length - 3
                  }টি মন্তব্য দেখুন`}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Comments;